(function () {
  const shell = document.querySelector('[data-stream-countdown]');
  if (!shell) return;

  const label = document.getElementById('countdown-label');
  const status = document.getElementById('stream-status');
  const subtext = document.getElementById('stream-subtext');

  const STREAM_START = 18 * 60 * 60; // 6:00 PM CT
  const STREAM_END = 22 * 60 * 60;   // 10:00 PM CT

  function chicagoParts() {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).formatToParts(new Date());

    const mapped = {};
    parts.forEach((part) => {
      if (part.type !== 'literal') mapped[part.type] = part.value;
    });

    return {
      hour: Number(mapped.hour || 0),
      minute: Number(mapped.minute || 0),
      second: Number(mapped.second || 0)
    };
  }

  function formatSeconds(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
  }

  function updateCountdown() {
    const now = chicagoParts();
    const currentSeconds = (now.hour * 3600) + (now.minute * 60) + now.second;

    if (currentSeconds >= STREAM_START && currentSeconds < STREAM_END) {
      shell.classList.add('is-live');
      label.textContent = 'We are live right now';
      status.textContent = 'Live Now';
      subtext.textContent = 'Join 3G Sports on eBay Live until 10:00 PM Central.';
      return;
    }

    shell.classList.remove('is-live');
    let secondsUntilStart = 0;

    if (currentSeconds < STREAM_START) {
      secondsUntilStart = STREAM_START - currentSeconds;
      label.textContent = 'Countdown to Tonight’s Stream';
      subtext.textContent = 'Live daily on eBay Live at 6:00 PM Central.';
    } else {
      secondsUntilStart = (24 * 3600 - currentSeconds) + STREAM_START;
      label.textContent = 'Countdown to Tomorrow’s Stream';
      subtext.textContent = 'The next stream starts tomorrow at 6:00 PM Central.';
    }

    status.textContent = formatSeconds(secondsUntilStart);
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
})();
